//Components
import Vue from 'vue'

import ShortSearch from './components/short-search'
import InlineDocumentViewer from './components/documents/viewer'


Vue.component('short-search', ShortSearch)

export default [
  {
    path: "/app/short-search",
    component: ShortSearch,
    name: 'short-search'
  },
  {
    path: "/app/document/:type?/:id?/:parent?",
    component: InlineDocumentViewer,
    name: 'document-viewer'
  },
  {
    path: "/documentation",
    name: 'documentation',
    beforeEnter() {
      window.location.assign('/TAPI V2.postman_collection.html');
    },
  },
];
